import { Box, Typography } from 'shared/ui'

export const RolesPermissionsHeader = () => {
  return (
    <Box
      display='flex'
      justifyContent='space-between'
      paddingTop={'64px'}
      paddingBottom={'48px'}
      flex={'none'}
    >
      <Box display='flex' flexDirection='column' gap='4px'>
        <Typography ariaLabel='title' variant='heading-lg' color='var(--content-primary-primary)'>
          Roles & Permissions
        </Typography>
        <Typography
          ariaLabel='description'
          variant='body-md-regular'
          color='var(--content-primary-tertiary)'
        >
          Control what each role can access and manage across your organization
        </Typography>
      </Box>
    </Box>
  )
}
